import { Component, Input, Self, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NgModel } from '@angular/forms';

@Component({
    selector: 'ba-checkbox',
    styleUrls: ['./baCheckbox.scss'],
    templateUrl: './baCheckbox.html',
    providers: [NgModel]
})

export class BaCheckbox implements ControlValueAccessor {
    @Input() disabled:boolean;
    @Input() label:string;
    @Input() value:string;
    @Input() baCheckboxClass:string;

    @Output() onCheckboxChange = new EventEmitter<any>();

    public model: NgModel;
    public state: boolean;

    public constructor(@Self() state:NgModel) {
        this.model = state;
        state.valueAccessor = this;
    }

    public onChange(value: any): void {
        this.onCheckboxChange.emit(value);
    }

    public onTouch(value: any): void {
        console.log(value);

    }

    public writeValue(state: any): void {
        this.state = state;
    }

    public registerOnChange(fn: any): void {
        this.onChange = function(state: boolean) {
            this.writeValue(state);
            this.model.viewToModelUpdate(state);
        };
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baCheckbox/baCheckbox.component.ts